export default {
  data(){
    return {
      idiomas: [
        {value: 'pt-br', text: 'Português'},
        {value: 'en', text: 'English'},
        {value: 'es', text: 'Español'}
      ],
      paises: [
        {value: 'AF', text: 'Afghanistan'},
        {value: 'AL', text: 'Albania'},
        {value: 'DZ', text: 'Algeria'},
        {value: 'AS', text: 'American Samoa'},
        {value: 'AD', text: 'Andorra'},
        {value: 'AO', text: 'Angola'},
        {value: 'AG', text: 'Antigua and Barbuda'},
        {value: 'AR', text: 'Argentina'},
        {value: 'AM', text: 'Armenia'},
        {value: 'AW', text: 'Aruba'},
        {value: 'AU', text: 'Australia'},
        {value: 'AT', text: 'Austria'},
        {value: 'AZ', text: 'Azerbaijan'},
        {value: 'BS', text: 'Bahamas'},
        {value: 'BH', text: 'Bahrain'},
        {value: 'BD', text: 'Bangladesh'},
        {value: 'BB', text: 'Barbados'},
        {value: 'BY', text: 'Belarus'},
        {value: 'BE', text: 'Belgium'},
        {value: 'BZ', text: 'Belize'},
        {value: 'BJ', text: 'Benin'},
        {value: 'BM', text: 'Bermuda'},
        {value: 'BT', text: 'Bhutan'},
        {value: 'BO', text: 'Bolivia, Plurinational State of'},
        {value: 'BQ', text: 'Bonaire, Sint Eustatius and Saba'},
        {value: 'BA', text: 'Bosnia and Herzegovina'},
        {value: 'BW', text: 'Botswana'},
        {value: 'BV', text: 'Bouvet Island'},
        {value: 'BR', text: 'Brasil'},
        {value: 'IO', text: 'British Indian Ocean Territory'},
        {value: 'BN', text: 'Brunei Darussalam'},
        {value: 'BG', text: 'Bulgaria'},
        {value: 'BF', text: 'Burkina Faso'},
        {value: 'BI', text: 'Burundi'},
        {value: 'CV', text: 'Cabo Verde'},
        {value: 'KH', text: 'Cambodia'},
        {value: 'CM', text: 'Cameroon'},
        {value: 'CA', text: 'Canada'},
        {value: 'KY', text: 'Cayman Islands'},
        {value: 'CF', text: 'Central African Republic'},
        {value: 'TD', text: 'Chad'},
        {value: 'CL', text: 'Chile'},
        {value: 'CN', text: 'China'},
        {value: 'CX', text: 'Christmas Island'},
        {value: 'CC', text: 'Cocos (Keeling) Islands'},
        {value: 'CO', text: 'Colombia'},
        {value: 'KM', text: 'Comoros'},
        {value: 'CG', text: 'Congo'},
        {value: 'CD', text: 'Congo, the Democratic Republic of the'},
        {value: 'CK', text: 'Cook Islands'},
        {value: 'CR', text: 'Costa Rica'},
        {value: 'HR', text: 'Croatia'},
        {value: 'CU', text: 'Cuba'},
        {value: 'CW', text: 'Curaçao'},
        {value: 'CY', text: 'Cyprus'},
        {value: 'CZ', text: 'Czech Republic'},
        {value: 'DK', text: 'Denmark'},
        {value: 'DJ', text: 'Djibouti'},
        {value: 'DM', text: 'Dominica'},
        {value: 'DO', text: 'Dominican Republic'},
        {value: 'EC', text: 'Ecuador'},
        {value: 'EG', text: 'Egypt'},
        {value: 'SV', text: 'El Salvador'},
        {value: 'GQ', text: 'Equatorial Guinea'},
        {value: 'ER', text: 'Eritrea'},
        {value: 'EE', text: 'Estonia'},
        {value: 'SZ', text: 'Eswatini'},
        {value: 'ET', text: 'Ethiopia'},
        {value: 'FK', text: 'Falkland Islands (Malvinas)'},
        {value: 'FO', text: 'Faroe Islands'},
        {value: 'FJ', text: 'Fiji'},
        {value: 'FI', text: 'Finland'},
        {value: 'FR', text: 'France'},
        {value: 'GF', text: 'French Guiana'},
        {value: 'PF', text: 'French Polynesia'},
        {value: 'TF', text: 'French Southern Territories'},
        {value: 'GA', text: 'Gabon'},
        {value: 'GM', text: 'Gambia'},
        {value: 'GE', text: 'Georgia'},
        {value: 'DE', text: 'Germany'},
        {value: 'GH', text: 'Ghana'},
        {value: 'GI', text: 'Gibraltar'},
        {value: 'GR', text: 'Greece'},
        {value: 'GL', text: 'Greenland'},
        {value: 'GD', text: 'Grenada'},
        {value: 'GP', text: 'Guadeloupe'},
        {value: 'GU', text: 'Guam'},
        {value: 'GT', text: 'Guatemala'},
        {value: 'GG', text: 'Guernsey'},
        {value: 'GN', text: 'Guinea'},
        {value: 'GW', text: 'Guinea-Bissau'},
        {value: 'GY', text: 'Guyana'},
        {value: 'HT', text: 'Haiti'},
        {value: 'HM', text: 'Heard Island and McDonald Islands'},
        {value: 'VA', text: 'Holy See (Vatican City State)'},
        {value: 'HN', text: 'Honduras'},
        {value: 'HK', text: 'Hong Kong'},
        {value: 'HU', text: 'Hungary'},
        {value: 'IS', text: 'Iceland'},
        {value: 'IN', text: 'India'},
        {value: 'ID', text: 'Indonesia'},
        {value: 'IR', text: 'Iran, Islamic Republic of'},
        {value: 'IQ', text: 'Iraq'},
        {value: 'IE', text: 'Ireland'},
        {value: 'IM', text: 'Isle of Man'},
        {value: 'IL', text: 'Israel'},
        {value: 'IT', text: 'Italy'},
        {value: 'JM', text: 'Jamaica'},
        {value: 'JP', text: 'Japan'},
        {value: 'JE', text: 'Jersey'},
        {value: 'JO', text: 'Jordan'},
        {value: 'KZ', text: 'Kazakhstan'},
        {value: 'KE', text: 'Kenya'},
        {value: 'KI', text: 'Kiribati'},
        {value: 'KR', text: 'Korea, Republic of'},
        {value: 'KW', text: 'Kuwait'},
        {value: 'KG', text: 'Kyrgyzstan'},
        {value: 'LV', text: 'Latvia'},
        {value: 'LB', text: 'Lebanon'},
        {value: 'LS', text: 'Lesotho'},
        {value: 'LR', text: 'Liberia'},
        {value: 'LY', text: 'Libya'},
        {value: 'LI', text: 'Liechtenstein'},
        {value: 'LT', text: 'Lithuania'},
        {value: 'LU', text: 'Luxembourg'},
        {value: 'MO', text: 'Macao'},
        {value: 'MG', text: 'Madagascar'},
        {value: 'MW', text: 'Malawi'},
        {value: 'MY', text: 'Malaysia'},
        {value: 'MV', text: 'Maldives'},
        {value: 'ML', text: 'Mali'},
        {value: 'MT', text: 'Malta'},
        {value: 'MH', text: 'Marshall Islands'},
        {value: 'MQ', text: 'Martinique'},
        {value: 'MR', text: 'Mauritania'},
        {value: 'MU', text: 'Mauritius'},
        {value: 'YT', text: 'Mayotte'},
        {value: 'MX', text: 'Mexico'},
        {value: 'FM', text: 'Micronesia, Federated States of'},
        {value: 'MD', text: 'Moldova, Republic of'},
        {value: 'MC', text: 'Monaco'},
        {value: 'MN', text: 'Mongolia'},
        {value: 'ME', text: 'Montenegro'},
        {value: 'MS', text: 'Montserrat'},
        {value: 'MA', text: 'Morocco'},
        {value: 'MZ', text: 'Mozambique'},
        {value: 'MM', text: 'Myanmar'},
        {value: 'NA', text: 'Namibia'},
        {value: 'NR', text: 'Nauru'},
        {value: 'NP', text: 'Nepal'},
        {value: 'NL', text: 'Netherlands'},
        {value: 'NC', text: 'New Caledonia'},
        {value: 'NZ', text: 'New Zealand'},
        {value: 'NI', text: 'Nicaragua'},
        {value: 'NE', text: 'Niger'},
        {value: 'NG', text: 'Nigeria'},
        {value: 'NU', text: 'Niue'},
        {value: 'NF', text: 'Norfolk Island'},
        {value: 'MK', text: 'North Macedonia'},
        {value: 'MP', text: 'Northern Mariana Islands'},
        {value: 'NO', text: 'Norway'},
        {value: 'OM', text: 'Oman'},
        {value: 'PK', text: 'Pakistan'},
        {value: 'PW', text: 'Palau'},
        {value: 'PS', text: 'Palestine, State of'},
        {value: 'PA', text: 'Panama'},
        {value: 'PG', text: 'Papua New Guinea'},
        {value: 'PY', text: 'Paraguay'},
        {value: 'PE', text: 'Peru'},
        {value: 'PH', text: 'Philippines'},
        {value: 'PN', text: 'Pitcairn'},
        {value: 'PL', text: 'Poland'},
        {value: 'PT', text: 'Portugal'},
        {value: 'PR', text: 'Puerto Rico'},
        {value: 'QA', text: 'Qatar'},
        {value: 'RE', text: 'Réunion'},
        {value: 'RO', text: 'Romania'},
        {value: 'RU', text: 'Russian Federation'},
        {value: 'RW', text: 'Rwanda'},
        {value: 'BL', text: 'Saint Barthélemy'},
        {value: 'SH', text: 'Saint Helena, Ascension and Tristan da Cunha'},
        {value: 'KN', text: 'Saint Kitts and Nevis'},
        {value: 'LC', text: 'Saint Lucia'},
        {value: 'MF', text: 'Saint Martin (French part)'},
        {value: 'PM', text: 'Saint Pierre and Miquelon'},
        {value: 'VC', text: 'Saint Vincent and the Grenadines'},
        {value: 'WS', text: 'Samoa'},
        {value: 'SM', text: 'San Marino'},
        {value: 'ST', text: 'Sao Tome and Principe'},
        {value: 'SA', text: 'Saudi Arabia'},
        {value: 'SN', text: 'Senegal'},
        {value: 'RS', text: 'Serbia'},
        {value: 'SC', text: 'Seychelles'},
        {value: 'SL', text: 'Sierra Leone'},
        {value: 'SG', text: 'Singapore'},
        {value: 'SX', text: 'Sint Maarten (Dutch part)'},
        {value: 'SK', text: 'Slovakia'},
        {value: 'SI', text: 'Slovenia'},
        {value: 'SB', text: 'Solomon Islands'},
        {value: 'SO', text: 'Somalia'},
        {value: 'ZA', text: 'South Africa'},
        {value: 'GS', text: 'South Georgia and the South Sandwich Islands'},
        {value: 'SS', text: 'South Sudan'},
        {value: 'ES', text: 'Spain'},
        {value: 'LK', text: 'Sri Lanka'},
        {value: 'SD', text: 'Sudan'},
        {value: 'SR', text: 'Suriname'},
        {value: 'SJ', text: 'Svalbard and Jan Mayen'},
        {value: 'SE', text: 'Sweden'},
        {value: 'CH', text: 'Switzerland'},
        {value: 'SY', text: 'Syrian Arab Republic'},
        {value: 'TW', text: 'Taiwan, Province of China'},
        {value: 'TJ', text: 'Tajikistan'},
        {value: 'TZ', text: 'Tanzania, United Republic of'},
        {value: 'TH', text: 'Thailand'},
        {value: 'TL', text: 'Timor-Leste'},
        {value: 'TG', text: 'Togo'},
        {value: 'TK', text: 'Tokelau'},
        {value: 'TO', text: 'Tonga'},
        {value: 'TT', text: 'Trinidad and Tobago'},
        {value: 'TN', text: 'Tunisia'},
        {value: 'TR', text: 'Turkey'},
        {value: 'TM', text: 'Turkmenistan'},
        {value: 'TC', text: 'Turks and Caicos Islands'},
        {value: 'TV', text: 'Tuvalu'},
        {value: 'UG', text: 'Uganda'},
        {value: 'UA', text: 'Ukraine'},
        {value: 'AE', text: 'United Arab Emirates'},
        {value: 'GB', text: 'United Kingdom of Great Britain and Northern Ireland'},
        {value: 'US', text: 'United States of America'},
        {value: 'UY', text: 'Uruguay'},
        {value: 'UZ', text: 'Uzbekistan'},
        {value: 'VU', text: 'Vanuatu'},
        {value: 'VE', text: 'Venezuela, Bolivarian Republic of'},
        {value: 'VN', text: 'Viet Nam'},
        {value: 'VG', text: 'Virgin Islands, British'},
        {value: 'VI', text: 'Virgin Islands, U.S.'},
        {value: 'WF', text: 'Wallis and Futuna'},
        {value: 'EH', text: 'Western Sahara'},
        {value: 'YE', text: 'Yemen'},
        {value: 'ZM', text: 'Zambia'},
        {value: 'ZW', text: 'Zimbabwe'}
      ],
      moedas: [
        {value: 'AED', text: 'United Arab Emirates Dirham', pais: 'AE'},
        {value: 'AFN', text: 'Afghan Afghani', pais: 'AF'},
        {value: 'ALL', text: 'Albanian Lek', pais: 'AL'},
        {value: 'AMD', text: 'Armenian Dram', pais: 'AM'},
        {value: 'ANG', text: 'Netherlands Antillean Guilder', pais: 'AN'},
        {value: 'AOA', text: 'Angolan Kwanza', pais: 'AO'},
        {value: 'ARS', text: 'Argentine Peso', pais: 'AR'},
        {value: 'AUD', text: 'Australian Dollar', pais: 'AU'},
        {value: 'AWG', text: 'Aruban Florin', pais: 'AW'},
        {value: 'AZN', text: 'Azerbaijani Manat', pais: 'AZ'},
        {value: 'BAM', text: 'Bosnia-Herzegovina Convertible Mark', pais: 'BA'},
        {value: 'BBD', text: 'Barbadian Dollar', pais: 'BB'},
        {value: 'BDT', text: 'Bangladeshi Taka', pais: 'BD'},
        {value: 'BGN', text: 'Bulgarian Lev', pais: 'BG'},
        {value: 'BHD', text: 'Bahraini Dinar', pais: 'BH'},
        {value: 'BIF', text: 'Burundian Franc', pais: 'BI'},
        {value: 'BMD', text: 'Bermudian Dollar', pais: 'BM'},
        {value: 'BND', text: 'Brunei Dollar', pais: 'BN'},
        {value: 'BOB', text: 'Bolivian Boliviano', pais: 'BO'},
        {value: 'BRL', text: 'Real', pais: 'BR'},
        {value: 'BSD', text: 'Bahamian Dollar', pais: 'BS'},
        {value: 'BTN', text: 'Bhutanese Ngultrum', pais: 'BT'},
        {value: 'BWP', text: 'Botswana Pula', pais: 'BW'},
        {value: 'BYN', text: 'Belarusian Ruble', pais: 'BY'},
        {value: 'BZD', text: 'Belize Dollar', pais: 'BZ'},
        {value: 'CAD', text: 'Canadian Dollar', pais: 'CA'},
        {value: 'CDF', text: 'Congolese Franc', pais: 'CD'},
        {value: 'CHF', text: 'Swiss Franc', pais: 'CH'},
        {value: 'CLP', text: 'Chilean Peso', pais: 'CL'},
        {value: 'CNY', text: 'Chinese Yuan', pais: 'CN'},
        {value: 'COP', text: 'Colombian Peso', pais: 'CO'},
        {value: 'CRC', text: 'Costa Rican Colón', pais: 'CR'},
        {value: 'CUC', text: 'Cuban Convertible Peso', pais: 'CU'},
        {value: 'CUP', text: 'Cuban Peso', pais: 'CU'},
        {value: 'CVE', text: 'Cape Verdean Escudo', pais: 'CV'},
        {value: 'CZK', text: 'Czech Republic Koruna', pais: 'CZ'},
        {value: 'DJF', text: 'Djiboutian Franc', pais: 'DJ'},
        {value: 'DKK', text: 'Danish Krone', pais: 'DK'},
        {value: 'DOP', text: 'Dominican Peso', pais: 'DO'},
        {value: 'DZD', text: 'Algerian Dinar', pais: 'DZ'},
        {value: 'EGP', text: 'Egyptian Pound', pais: 'EG'},
        {value: 'ERN', text: 'Eritrean Nakfa', pais: 'ER'},
        {value: 'ETB', text: 'Ethiopian Birr', pais: 'ET'},
        {value: 'EUR', text: 'Euro', pais: 'EU'},
        {value: 'FJD', text: 'Fijian Dollar', pais: 'FJ'},
        {value: 'FKP', text: 'Falkland Islands Pound', pais: 'FK'},
        {value: 'FOK', text: 'Faroese Króna', pais: 'FO'},
        {value: 'GBP', text: 'British Pound Sterling', pais: 'GB'},
        {value: 'GEL', text: 'Georgian Lari', pais: 'GE'},
        {value: 'GGP', text: 'Guernsey Pound', pais: 'GG'},
        {value: 'GHS', text: 'Ghanaian Cedi', pais: 'GH'},
        {value: 'GIP', text: 'Gibraltar Pound', pais: 'GI'},
        {value: 'GMD', text: 'Gambian Dalasi', pais: 'GM'},
        {value: 'GNF', text: 'Guinean Franc', pais: 'GN'},
        {value: 'GTQ', text: 'Guatemalan Quetzal', pais: 'GT'},
        {value: 'GYD', text: 'Guyanese Dollar', pais: 'GY'},
        {value: 'HKD', text: 'Hong Kong Dollar', pais: 'HK'},
        {value: 'HNL', text: 'Honduran Lempira', pais: 'HN'},
        {value: 'HRK', text: 'Croatian Kuna', pais: 'HR'},
        {value: 'HTG', text: 'Haitian Gourde', pais: 'HT'},
        {value: 'HUF', text: 'Hungarian Forint', pais: 'HU'},
        {value: 'IDR', text: 'Indonesian Rupiah', pais: 'ID'},
        {value: 'ILS', text: 'Israeli New Sheqel', pais: 'IL'},
        {value: 'IMP', text: 'Isle of Man Pound', pais: 'IM'},
        {value: 'INR', text: 'Indian Rupee', pais: 'IN'},
        {value: 'IQD', text: 'Iraqi Dinar', pais: 'IQ'},
        {value: 'IRR', text: 'Iranian Rial', pais: 'IR'},
        {value: 'ISK', text: 'Icelandic Króna', pais: 'IS'},
        {value: 'JEP', text: 'Jersey Pound', pais: 'JE'},
        {value: 'JMD', text: 'Jamaican Dollar', pais: 'JM'},
        {value: 'JOD', text: 'Jordanian Dinar', pais: 'JO'},
        {value: 'JPY', text: 'Japanese Yen', pais: 'JP'},
        {value: 'KES', text: 'Kenyan Shilling', pais: 'KE'},
        {value: 'KGS', text: 'Kyrgystani Som', pais: 'KG'},
        {value: 'KHR', text: 'Cambodian Riel', pais: 'KH'},
        {value: 'KID', text: 'Kiribati Dollar', pais: 'KI'},
        {value: 'KMF', text: 'Comorian Franc', pais: 'KM'},
        {value: 'KRW', text: 'South Korean Won', pais: 'KR'},
        {value: 'KWD', text: 'Kuwaiti Dinar', pais: 'KW'},
        {value: 'KYD', text: 'Cayman Islands Dollar', pais: 'KY'},
        {value: 'KZT', text: 'Kazakhstani Tenge', pais: 'KZ'},
        {value: 'LAK', text: 'Laotian Kip', pais: 'LA'},
        {value: 'LBP', text: 'Lebanese Pound', pais: 'LB'},
        {value: 'LKR', text: 'Sri Lankan Rupee', pais: 'LK'},
        {value: 'LRD', text: 'Liberian Dollar', pais: 'LR'},
        {value: 'LSL', text: 'Lesotho Loti', pais: 'LS'},
        {value: 'LYD', text: 'Libyan Dinar', pais: 'LY'},
        {value: 'MAD', text: 'Moroccan Dirham', pais: 'MA'},
        {value: 'MDL', text: 'Moldovan Leu', pais: 'MD'},
        {value: 'MGA', text: 'Malagasy Ariary', pais: 'MG'},
        {value: 'MKD', text: 'Macedonian Denar', pais: 'MK'},
        {value: 'MMK', text: 'Myanma Kyat', pais: 'MM'},
        {value: 'MNT', text: 'Mongolian Tugrik', pais: 'MN'},
        {value: 'MOP', text: 'Macanese Pataca', pais: 'MO'},
        {value: 'MRU', text: 'Mauritanian Ouguiya', pais: 'MR'},
        {value: 'MUR', text: 'Mauritian Rupee', pais: 'MU'},
        {value: 'MVR', text: 'Maldivian Rufiyaa', pais: 'MV'},
        {value: 'MWK', text: 'Malawian Kwacha', pais: 'MW'},
        {value: 'MXN', text: 'Mexican Peso', pais: 'MX'},
        {value: 'MYR', text: 'Malaysian Ringgit', pais: 'MY'},
        {value: 'MZN', text: 'Mozambican Metical', pais: 'MZ'},
        {value: 'NAD', text: 'Namibian Dollar', pais: 'NA'},
        {value: 'NGN', text: 'Nigerian Naira', pais: 'NG'},
        {value: 'NIO', text: 'Nicaraguan Córdoba', pais: 'NI'},
        {value: 'NOK', text: 'Norwegian Krone', pais: 'NO'},
        {value: 'NPR', text: 'Nepalese Rupee', pais: 'NP'},
        {value: 'NZD', text: 'New Zealand Dollar', pais: 'NZ'},
        {value: 'OMR', text: 'Omani Rial', pais: 'OM'},
        {value: 'PAB', text: 'Panamanian Balboa', pais: 'PA'},
        {value: 'PEN', text: 'Peruvian Nuevo Sol', pais: 'PE'},
        {value: 'PGK', text: 'Papua New Guinean Kina', pais: 'PG'},
        {value: 'PHP', text: 'Philippine Peso', pais: 'PH'},
        {value: 'PKR', text: 'Pakistani Rupee', pais: 'PK'},
        {value: 'PLN', text: 'Polish Zloty', pais: 'PL'},
        {value: 'PYG', text: 'Paraguayan Guarani', pais: 'PY'},
        {value: 'QAR', text: 'Qatari Rial', pais: 'QA'},
        {value: 'RON', text: 'Romanian Leu', pais: 'RO'},
        {value: 'RSD', text: 'Serbian Dinar', pais: 'RS'},
        {value: 'RUB', text: 'Russian Ruble', pais: 'RU'},
        {value: 'RWF', text: 'Rwandan Franc', pais: 'RW'},
        {value: 'SAR', text: 'Saudi Riyal', pais: 'SA'},
        {value: 'SBD', text: 'Solomon Islands Dollar', pais: 'SB'},
        {value: 'SCR', text: 'Seychellois Rupee', pais: 'SC'},
        {value: 'SDG', text: 'Sudanese Pound', pais: 'SD'},
        {value: 'SEK', text: 'Swedish Krona', pais: 'SE'},
        {value: 'SGD', text: 'Singapore Dollar', pais: 'SG'},
        {value: 'SHP', text: 'Saint Helena Pound', pais: 'SH'},
        {value: 'SLL', text: 'Sierra Leonean Leone', pais: 'SL'},
        {value: 'SOS', text: 'Somali Shilling', pais: 'SO'},
        {value: 'SRD', text: 'Surinamese Dollar', pais: 'SR'},
        {value: 'SSP', text: 'South Sudanese Pound', pais: 'SS'},
        {value: 'STN', text: 'São Tomé and Príncipe Dobra', pais: 'ST'},
        {value: 'SYP', text: 'Syrian Pound', pais: 'SY'},
        {value: 'SZL', text: 'Swazi Lilangeni', pais: 'SZ'},
        {value: 'THB', text: 'Thai Baht', pais: 'TH'},
        {value: 'TJS', text: 'Tajikistani Somoni', pais: 'TJ'},
        {value: 'TMT', text: 'Turkmenistani Manat', pais: 'TM'},
        {value: 'TND', text: 'Tunisian Dinar', pais: 'TN'},
        {value: 'TOP', text: 'Tongan Paʻanga', pais: 'TO'},
        {value: 'TRY', text: 'Turkish Lira', pais: 'TR'},
        {value: 'TTD', text: 'Trinidad and Tobago Dollar', pais: 'TT'},
        {value: 'TVD', text: 'Tuvaluan Dollar', pais: 'TV'},
        {value: 'TWD', text: 'New Taiwan Dollar', pais: 'TW'},
        {value: 'TZS', text: 'Tanzanian Shilling', pais: 'TZ'},
        {value: 'UAH', text: 'Ukrainian Hryvnia', pais: 'UA'},
        {value: 'UGX', text: 'Ugandan Shilling', pais: 'UG'},
        {value: 'USD', text: 'United States Dollar', pais: 'US'},
        {value: 'UYU', text: 'Uruguayan Peso', pais: 'UY'},
        {value: 'UZS', text: 'Uzbekistan Som', pais: 'UZ'},
        {value: 'VES', text: 'Venezuelan Bolívar Soberano', pais: 'VE'},
        {value: 'VND', text: 'Vietnamese Dong', pais: 'VN'},
        {value: 'VUV', text: 'Vanuatu Vatu', pais: 'VU'},
        {value: 'WST', text: 'Samoan Tala', pais: 'WS'},
        {value: 'XAF', text: 'CFA Franc BEAC', pais: 'XA'},
        {value: 'XCD', text: 'East Caribbean Dollar', pais: 'XC'},
        {value: 'XDR', text: 'Special Drawing Rights', pais: 'XD'},
        {value: 'XOF', text: 'CFA Franc BCEAO', pais: 'XO'},
        {value: 'XPF', text: 'CFP Franc', pais: 'XP'},
        {value: 'YER', text: 'Yemeni Rial', pais: 'YE'},
        {value: 'ZAR', text: 'South African Rand', pais: 'ZA'},
        {value: 'ZMW', text: 'Zambian Kwacha', pais: 'ZM'},
        {value: 'ZWL', text: 'Zimbabwean Dollar', pais: 'ZW'}
      ],
      codigosTelefones: [
        { pais: 'AF', name: 'Afghanistan', telefone: '+93' },
        { pais: 'AL', name: 'Albania', telefone: '+355' },
        { pais: 'DZ', name: 'Algeria', telefone: '+213' },
        { pais: 'AS', name: 'American Samoa', telefone: '+1684' },
        { pais: 'AD', name: 'Andorra', telefone: '+376' },
        { pais: 'AO', name: 'Angola', telefone: '+244' },
        { pais: 'AG', name: 'Antigua and Barbuda', telefone: '+1268' },
        { pais: 'AR', name: 'Argentina', telefone: '+54' },
        { pais: 'AM', name: 'Armenia', telefone: '+374' },
        { pais: 'AW', name: 'Aruba', telefone: '+297' },
        { pais: 'AU', name: 'Australia', telefone: '+61' },
        { pais: 'AT', name: 'Austria', telefone: '+43' },
        { pais: 'AZ', name: 'Azerbaijan', telefone: '+994' },
        { pais: 'BS', name: 'Bahamas', telefone: '+1242' },
        { pais: 'BH', name: 'Bahrain', telefone: '+973' },
        { pais: 'BD', name: 'Bangladesh', telefone: '+880' },
        { pais: 'BB', name: 'Barbados', telefone: '+1246' },
        { pais: 'BY', name: 'Belarus', telefone: '+375' },
        { pais: 'BE', name: 'Belgium', telefone: '+32' },
        { pais: 'BZ', name: 'Belize', telefone: '+501' },
        { pais: 'BJ', name: 'Benin', telefone: '+229' },
        { pais: 'BM', name: 'Bermuda', telefone: '+1441' },
        { pais: 'BT', name: 'Bhutan', telefone: '+975' },
        { pais: 'BO', name: 'Bolivia', telefone: '+591' },
        { pais: 'BA', name: 'Bosnia and Herzegovina', telefone: '+387' },
        { pais: 'BW', name: 'Botswana', telefone: '+267' },
        { pais: 'BR', name: 'Brazil', telefone: '+55' },
        { pais: 'VG', name: 'British Virgin Islands', telefone: '+1284' },
        { pais: 'BN', name: 'Brunei', telefone: '+673' },
        { pais: 'BG', name: 'Bulgaria', telefone: '+359' },
        { pais: 'BF', name: 'Burkina Faso', telefone: '+226' },
        { pais: 'BI', name: 'Burundi', telefone: '+257' },
        { pais: 'KH', name: 'Cambodia', telefone: '+855' },
        { pais: 'CM', name: 'Cameroon', telefone: '+237' },
        /*   { pais: 'CA', name: 'Canada', telefone: '+1' },*/
        { pais: 'CV', name: 'Cape Verde', telefone: '+238' },
        { pais: 'KY', name: 'Cayman Islands', telefone: '+1345' },
        { pais: 'CF', name: 'Central African Republic', telefone: '+236' },
        { pais: 'TD', name: 'Chad', telefone: '+235' },
        { pais: 'CL', name: 'Chile', telefone: '+56' },
        { pais: 'CN', name: 'China', telefone: '+86' },
        { pais: 'CO', name: 'Colombia', telefone: '+57' },
        { pais: 'KM', name: 'Comoros', telefone: '+269' },
        { pais: 'CG', name: 'Congo (Republic)', telefone: '+242' },
        { pais: 'CR', name: 'Costa Rica', telefone: '+506' },
        { pais: 'HR', name: 'Croatia', telefone: '+385' },
        { pais: 'CU', name: 'Cuba', telefone: '+53' },
        { pais: 'CY', name: 'Cyprus', telefone: '+357' },
        { pais: 'CZ', name: 'Czech Republic', telefone: '+420' },
        { pais: 'CD', name: 'Democratic Republic of the Congo', telefone: '+243' },
        { pais: 'DK', name: 'Denmark', telefone: '+45' },
        { pais: 'DJ', name: 'Djibouti', telefone: '+253' },
        { pais: 'DM', name: 'Dominica', telefone: '+1767' },
        { pais: 'DO', name: 'Dominican Republic', telefone: '+1809' },
        { pais: 'EC', name: 'Ecuador', telefone: '+593' },
        { pais: 'EG', name: 'Egypt', telefone: '+20' },
        { pais: 'SV', name: 'El Salvador', telefone: '+503' },
        { pais: 'GQ', name: 'Equatorial Guinea', telefone: '+240' },
        { pais: 'ER', name: 'Eritrea', telefone: '+291' },
        { pais: 'EE', name: 'Estonia', telefone: '+372' },
        { pais: 'ET', name: 'Ethiopia', telefone: '+251' },
        { pais: 'FO', name: 'Faroe Islands', telefone: '+298' },
        { pais: 'FJ', name: 'Fiji', telefone: '+679' },
        { pais: 'FI', name: 'Finland', telefone: '+358' },
        { pais: 'FR', name: 'France', telefone: '+33' },
        { pais: 'GF', name: 'French Guiana', telefone: '+594' },
        { pais: 'PF', name: 'French Polynesia', telefone: '+689' },
        { pais: 'GA', name: 'Gabon', telefone: '+241' },
        { pais: 'GM', name: 'Gambia', telefone: '+220' },
        { pais: 'GE', name: 'Georgia', telefone: '+995' },
        { pais: 'DE', name: 'Germany', telefone: '+49' },
        { pais: 'GH', name: 'Ghana', telefone: '+233' },
        { pais: 'GI', name: 'Gibraltar', telefone: '+350' },
        { pais: 'GR', name: 'Greece', telefone: '+30' },
        { pais: 'GL', name: 'Greenland', telefone: '+299' },
        { pais: 'GD', name: 'Grenada', telefone: '+1473' },
        { pais: 'GP', name: 'Guadeloupe', telefone: '+590' },
        { pais: 'GU', name: 'Guam', telefone: '+1671' },
        { pais: 'GT', name: 'Guatemala', telefone: '+502' },
        { pais: 'GN', name: 'Guinea', telefone: '+224' },
        { pais: 'GW', name: 'Guinea-Bissau', telefone: '+245' },
        { pais: 'GY', name: 'Guyana', telefone: '+592' },
        { pais: 'HT', name: 'Haiti', telefone: '+509' },
        { pais: 'HN', name: 'Honduras', telefone: '+504' },
        { pais: 'HK', name: 'Hong Kong', telefone: '+852' },
        { pais: 'HU', name: 'Hungary', telefone: '+36' },
        { pais: 'IS', name: 'Iceland', telefone: '+354' },
        { pais: 'IN', name: 'India', telefone: '+91' },
        { pais: 'ID', name: 'Indonesia', telefone: '+62' },
        { pais: 'IR', name: 'Iran', telefone: '+98' },
        { pais: 'IQ', name: 'Iraq', telefone: '+964' },
        { pais: 'IE', name: 'Ireland', telefone: '+353' },
        { pais: 'IL', name: 'Israel', telefone: '+972' },
        { pais: 'IT', name: 'Italy', telefone: '+39' },
        { pais: 'CI', name: 'Ivory Coast', telefone: '+225' },
        { pais: 'JM', name: 'Jamaica', telefone: '+1876' },
        { pais: 'JP', name: 'Japan', telefone: '+81' },
        { pais: 'JO', name: 'Jordan', telefone: '+962' },
        { pais: 'KZ', name: 'Kazakhstan', telefone: '+77' },
        { pais: 'KE', name: 'Kenya', telefone: '+254' },
        { pais: 'KW', name: 'Kuwait', telefone: '+965' },
        { pais: 'KG', name: 'Kyrgyzstan', telefone: '+996' },
        { pais: 'LA', name: 'Laos', telefone: '+856' },
        { pais: 'LV', name: 'Latvia', telefone: '+371' },
        { pais: 'LB', name: 'Lebanon', telefone: '+961' },
        { pais: 'LS', name: 'Lesotho', telefone: '+266' },
        { pais: 'LR', name: 'Liberia', telefone: '+231' },
        { pais: 'LY', name: 'Libya', telefone: '+218' },
        { pais: 'LI', name: 'Liechtenstein', telefone: '+423' },
        { pais: 'LT', name: 'Lithuania', telefone: '+370' },
        { pais: 'LU', name: 'Luxembourg', telefone: '+352' },
        { pais: 'MO', name: 'Macau', telefone: '+853' },
        { pais: 'MK', name: 'Macedonia', telefone: '+389' },
        { pais: 'MG', name: 'Madagascar', telefone: '+261' },
        { pais: 'MW', name: 'Malawi', telefone: '+265' },
        { pais: 'MY', name: 'Malaysia', telefone: '+60' },
        { pais: 'MV', name: 'Maldives', telefone: '+960' },
        { pais: 'ML', name: 'Mali', telefone: '+223' },
        { pais: 'MT', name: 'Malta', telefone: '+356' },
        { pais: 'MH', name: 'Marshall Islands', telefone: '+692' },
        { pais: 'MQ', name: 'Martinique', telefone: '+596' },
        { pais: 'MR', name: 'Mauritania', telefone: '+222' },
        { pais: 'MU', name: 'Mauritius', telefone: '+230' },
        { pais: 'YT', name: 'Mayotte', telefone: '+262' },
        { pais: 'MX', name: 'Mexico', telefone: '+52' },
        { pais: 'FM', name: 'Micronesia', telefone: '+691' },
        { pais: 'MD', name: 'Moldova', telefone: '+373' },
        { pais: 'MC', name: 'Monaco', telefone: '+377' },
        { pais: 'MN', name: 'Mongolia', telefone: '+976' },
        { pais: 'ME', name: 'Montenegro', telefone: '+382' },
        { pais: 'MS', name: 'Montserrat', telefone: '+1664' },
        { pais: 'MA', name: 'Morocco', telefone: '+212' },
        { pais: 'MZ', name: 'Mozambique', telefone: '+258' },
        { pais: 'MM', name: 'Myanmar', telefone: '+95' },
        { pais: 'NA', name: 'Namibia', telefone: '+264' },
        { pais: 'NP', name: 'Nepal', telefone: '+977' },
        { pais: 'NL', name: 'Netherlands', telefone: '+31' },
        { pais: 'NC', name: 'New Caledonia', telefone: '+687' },
        { pais: 'NZ', name: 'New Zealand', telefone: '+64' },
        { pais: 'NI', name: 'Nicaragua', telefone: '+505' },
        { pais: 'NE', name: 'Niger', telefone: '+227' },
        { pais: 'NG', name: 'Nigeria', telefone: '+234' },
        { pais: 'KP', name: 'North Korea', telefone: '+850' },
        { pais: 'MP', name: 'Northern Mariana Islands', telefone: '+1670' },
        { pais: 'NO', name: 'Norway', telefone: '+47' },
        { pais: 'OM', name: 'Oman', telefone: '+968' },
        { pais: 'PK', name: 'Pakistan', telefone: '+92' },
        { pais: 'PW', name: 'Palau', telefone: '+680' },
        { pais: 'PS', name: 'Palestine', telefone: '+970' },
        { pais: 'PA', name: 'Panama', telefone: '+507' },
        { pais: 'PG', name: 'Papua New Guinea', telefone: '+675' },
        { pais: 'PY', name: 'Paraguay', telefone: '+595' },
        { pais: 'PE', name: 'Peru', telefone: '+51' },
        { pais: 'PH', name: 'Philippines', telefone: '+63' },
        { pais: 'PL', name: 'Poland', telefone: '+48' },
        { pais: 'PT', name: 'Portugal', telefone: '+351' },
        { pais: 'PR', name: 'Puerto Rico', telefone: '+1787' },
        { pais: 'QA', name: 'Qatar', telefone: '+974' },
        { pais: 'RE', name: 'Reunion', telefone: '+262' },
        { pais: 'RO', name: 'Romania', telefone: '+40' },
        { pais: 'RU', name: 'Russia', telefone: '+7' },
        { pais: 'RW', name: 'Rwanda', telefone: '+250' },
        { pais: 'KN', name: 'Saint Kitts and Nevis', telefone: '+1869' },
        { pais: 'LC', name: 'Saint Lucia', telefone: '+1758' },
        { pais: 'WS', name: 'Samoa', telefone: '+685' },
        { pais: 'SM', name: 'San Marino', telefone: '+378' },
        { pais: 'SA', name: 'Saudi Arabia', telefone: '+966' },
        { pais: 'SN', name: 'Senegal', telefone: '+221' },
        { pais: 'RS', name: 'Serbia', telefone: '+381' },
        { pais: 'SL', name: 'Sierra Leone', telefone: '+232' },
        { pais: 'SG', name: 'Singapore', telefone: '+65' },
        { pais: 'SX', name: 'Sint Maarten', telefone: '+1721' },
        { pais: 'SK', name: 'Slovakia', telefone: '+421' },
        { pais: 'SI', name: 'Slovenia', telefone: '+386' },
        { pais: 'SO', name: 'Somalia', telefone: '+252' },
        { pais: 'ZA', name: 'South Africa', telefone: '+27' },
        { pais: 'KR', name: 'South Korea', telefone: '+82' },
        { pais: 'SS', name: 'South Sudan', telefone: '+211' },
        { pais: 'ES', name: 'Spain', telefone: '+34' },
        { pais: 'LK', name: 'Sri Lanka', telefone: '+94' },
        { pais: 'PM', name: 'Saint Pierre and Miquelon', telefone: '+508' },
        { pais: 'VC', name: 'Saint Vincent and the Grenadines', telefone: '+1784' },
        { pais: 'SD', name: 'Sudan', telefone: '+249' },
        { pais: 'SR', name: 'Suriname', telefone: '+597' },
        { pais: 'SZ', name: 'Swaziland', telefone: '+268' },
        { pais: 'SE', name: 'Sweden', telefone: '+46' },
        { pais: 'CH', name: 'Switzerland', telefone: '+41' },
        { pais: 'SY', name: 'Syria', telefone: '+963' },
        { pais: 'TW', name: 'Taiwan', telefone: '+886' },
        { pais: 'TJ', name: 'Tajikistan', telefone: '+992' },
        { pais: 'TZ', name: 'Tanzania', telefone: '+255' },
        { pais: 'TH', name: 'Thailand', telefone: '+66' },
        { pais: 'TG', name: 'Togo', telefone: '+228' },
        { pais: 'TO', name: 'Tonga', telefone: '+676' },
        { pais: 'TT', name: 'Trinidad and Tobago', telefone: '+1868' },
        { pais: 'TN', name: 'Tunisia', telefone: '+216' },
        { pais: 'TR', name: 'Turkey', telefone: '+90' },
        { pais: 'TM', name: 'Turkmenistan', telefone: '+993' },
        { pais: 'TC', name: 'Turks and Caicos Islands', telefone: '+1649' },
        { pais: 'UG', name: 'Uganda', telefone: '+256' },
        { pais: 'UA', name: 'Ukraine', telefone: '+380' },
        { pais: 'AE', name: 'United Arab Emirates', telefone: '+971' },
        { pais: 'GB', name: 'United Kingdom', telefone: '+44' },
        { pais: 'US', name: 'United States', telefone: '+1' },
        { pais: 'VI', name: 'United States Virgin Islands', telefone: '+1340' },
        { pais: 'UY', name: 'Uruguay', telefone: '+598' },
        { pais: 'UZ', name: 'Uzbekistan', telefone: '+998' },
        { pais: 'VU', name: 'Vanuatu', telefone: '+678' },
        { pais: 'VE', name: 'Venezuela', telefone: '+58' },
        { pais: 'VN', name: 'Vietnam', telefone: '+84' },
        { pais: 'YE', name: 'Yemen', telefone: '+967' },
        { pais: 'ZM', name: 'Zambia', telefone: '+260' },
        { pais: 'ZW', name: 'Zimbabwe', telefone: '+263' }
      ]
    }
  }
}
